import { render, staticRenderFns } from "./SubdivisionPermit.vue?vue&type=template&id=32cc9c10&"
import script from "./SubdivisionPermit.vue?vue&type=script&lang=ts&"
export * from "./SubdivisionPermit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports